export const agenda = [
    {
        'id': 1,
        'title': 'Hoy me reuní con mi amigo Ricardo Olguín, director de de "El Canal del Pueblo", así como con Karina Atanacio, conductora y reportera 🎤, con quienes realizamos una alianza para trabajar de forma coordinada para proyectar lo más importante del sector turístico.',
        'place': 'Pachuca de Soto',
        'start': '2024-01-09',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Hoy me reuní con mi amigo Ricardo Olguín, director de de &quot;El Canal del Pueblo&quot;, así como con Karina Atanacio, conductora y reportera 🎤, con quienes realizamos una alianza para trabajar de forma coordinada para proyectar lo más importante del sector turístico. <a href="https://t.co/BvKpkvK00I">pic.twitter.com/BvKpkvK00I</a></p>&mdash; Liz Quintanar (@LizQuintanarG) <a href="https://twitter.com/LizQuintanarG/status/1744910900610416972?ref_src=twsrc%5Etfw">January 10, 2024</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 2,
        'title': 'Ruta del queso Actopan',
        'place': 'Actopan',
        'start': '2024-01-10',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Ruta del Queso en <a href="https://twitter.com/hashtag/Actopa?src=hash&amp;ref_src=twsrc%5Etfw">#Actopa</a> <a href="https://t.co/Lh2moKYn6Q">https://t.co/Lh2moKYn6Q</a></p>&mdash; Liz Quintanar (@LizQuintanarG) <a href="https://twitter.com/LizQuintanarG/status/1745252022662619264?ref_src=twsrc%5Etfw">January 11, 2024</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 3,
        'title': 'La “Ruta del Queso” 🧀 es un evento creado por Cava de Quesos Deleite, una estrategia para que, visitantes y turistas, disfruten de un momento inolvidable. Este sitio está ubicado en Actopan, no olviden visitarlo',
        'place': 'Actopan',
        'start': '2024-01-10',
        'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">La “Ruta del Queso” 🧀 es un evento creado por Cava de Quesos Deleite, una estrategia para que, visitantes y turistas, disfruten de un momento inolvidable.<br><br>Este sitio está ubicado en Actopan, no olviden visitarlo 👇🏼<a href="https://t.co/XRcsMS0Bg1">https://t.co/XRcsMS0Bg1</a><a href="https://twitter.com/hashtag/HidalgoTieneAlgo?src=hash&amp;ref_src=twsrc%5Etfw">#HidalgoTieneAlgo</a></p>&mdash; Liz Quintanar (@LizQuintanarG) <a href="https://twitter.com/LizQuintanarG/status/1745252255446503888?ref_src=twsrc%5Etfw">January 11, 2024</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
    },
    {
        'id': 4,
        'title': 'Este lunes, llegaremos al WTC Veracruz para ser parte del “Tianguis Nacional de #PueblosMágicos 2024”.Viviremos este encuentro los 177 Pueblos Mágicos, incluyendo los 9 que tiene Hidalgo, así como los 32 Barrios Mágicos del país.',
        'place': 'Boca del Río, Veracruz',
        'start': '2024-09-09',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1833216272689205585?s=46>'
    },
    {
        'id': 5,
        'title': '¡Muy buenas tardes! Estoy en Boca del Río, Veracruz en donde #Hidalgo está presente en la 6ta. Edición del Tianguis Nacional de Pueblos Mágicos.Seguimos trabajando para promocionar a nuestros 9 Pueblos Mágicos y a nuestro Barrio “El Arbolito”, porque #HidalgoSeaPotencia',
        'place': 'Boca del Río, Veracruz',
        'start': '2024-09-10',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1833569393655128501?s=12>'
    },
    {
        'id': 6,
        'title': 'En la 6ta. Edición del Tianguis Nacional de Pueblos Mágicos, está presente un stand de medicina tradicional en el que, expertas y expertos de Acaxochitlán comparten su conocimiento ancestral a través de hierbas, guías espirituales y  una gran tradición ancestral.',
        'place': 'Boca del Río, Veracruz',
        'start': '2024-09-11',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1833931395464597921?s=48>'
    },
    {
        'id': 7,
        'title': '¡Hidalgo continúa presente en el Tianguis Nacional de #PueblosMágicos  !  ¡“El Asadero de Hidalgo”¡ Jesús y Octavio vienen así como los demás cocineros y cocineras tradicionales a engalanar esta fiesta del turismo en Boca del Rio.',
        'place': 'Boca del Río, Veracruz',
        'start': '2024-09-12',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1834305419948204189?s=48>'
    },
    {
        'id': 8,
        'title': '¡La Feria San Francisco Pachuca Hidalgo 2024 está a la vuelta de la esquina! Acabo de presentar nuestra maravillosa celebración en Punto México, en CDMX y no puedo esperar para compartir con todos ustedes la magia de Hidalgo. ¡Nos vemos pronto!',
        'place': 'Punto México, CDMX.',
        'start': '2024-09-17',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1836134939156222300?s=48>'
    },
    {
        'id': 9,
        'title': 'No se puede pensar en el desarrollo de #Hidalgo sin el apoyo de las y los empresarios hidalguenses, de las asociaciones y cámaras empresariales, por lo que agradezco a Ricardo Puga Aboytes, presidente de @CANACINTRA_Pch , por la invitación a esta 6ta. Sesión de trabajo.',
        'place': 'Pachuca',
        'start': '2024-09-18',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1836448963051811119?s=48>'
    },
    {
        'id': 10,
        'title': '¡Estoy súper emocionada!Hoy, la @SECTURHidalgo  firmó un convenio con Pastes Kiko’s.Este acuerdo será un parteaguas para el turismo y los deliciosos pastes Kiko’s, que nos ayudarán a difundir las maravillas de nuestro estado.  ¡Gracias por ser un referente de marca hidalguense!',
        'place': 'Pachuca',
        'start': '2024-09-18',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1836475680919343487?s=48>'
    },
    {
        'id': 11,
        'title': '¡El turismo social nos inspira a conectar con lo nuestro! Las y los estudiantes de COBAEH de Santiago Tezontlale, emocionados por esta experiencia, fueron recibidos en el Museo de las Miniaturas.',
        'place': 'Pachuca',
        'start': '2024-09-19',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1836841047823110171?s=46>'
    },
    {
        'id': 12,
        'title': '¡El turismo es nuestra fuerza para crecer! 😍 Esta tarde nos reunimos en la Secretaría de Turismo con presidentes municipales y directores de turismo para presentar los programas de Geoparque Comarca Minera y Pueblos Mágicos.',
        'place': 'Pachuca',
        'start': '2024-09-19',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1836878038530936964?s=46>'
    },
    {
        'id': 13,
        'title': '¡Hoy tuve el honor de ser parte de la inauguración de la 24 Feria del Libro Infantil y Juvenil Hidalgo 2024! Como Secretaria de Turismo me complace ver cómo nuestro estado se convierte en un epicentro de conocimiento, creatividad y fomento a la lectura.',
        'place': 'Pachuca',
        'start': '2024-09-20',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1837233078885904833?s=46>'
    },
    {
        'id': 14,
        'title': 'Iniciamos la semana con gran entusiasmo en la comunidad González Ortega, Santiago de Anaya, para dar comienzo a la construcción de los nuevos módulos artesanales.Este proyecto impulsará el talento local y fortalecerá la economía de nuestros artesanos.',
        'place': 'Santiago de Anaya',
        'start': '2024-09-23',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1838308543625126020?s=46>'
    },
    {
        'id': 15,
        'title': 'Estamos aquí para garantizar que tu experiencia en la Feria “San Francisco” Pachuca 2024 sea inolvidable. Recorramos juntos las instalaciones, donde la calidad y la pasión se entrelazan. Late con orgullo y disfruta de todo lo que Hidalgo tiene para ofrecerte.',
        'place': 'Pachuca',
        'start': '2024-09-24',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1838633141067469080?s=46>'
    },
    {
        'id': 16,
        'title': 'Estoy muy feliz de estar en la Feria Turística 🎡Empresarial Hidalgo! Aquí, el turismo y los negocios se encuentran para crear oportunidades únicas. Juntos, impulsamos el crecimiento de nuestro increíble estado. ¡Vamos por más!🎊#HidalgoTieneAlgo',
        'place': 'Pachuca',
        'start': '2024-09-24',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1838668155876430120?s=46>'
    },
    {
        'id': 17,
        'title': '¡Siempre es un gusto compartir con el público de Canal 6 todas las maravillas turísticas de nuestro querido estado! 🎥✨Gracias, Juan Carlos Santamaría, por esta gran oportunidad de invitar a las y los televidentes a vivir la @FeriaHidalgo  ¡Les esperamos con los brazos abiertos!',
        'place': 'Pachuca',
        'start': '2024-09-26',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1839390321177993580?s=46>'
    },
    {
        'id': 18,
        'title': '¡Hidalgo Tiene Algo! Y es un compromiso de todas y todos por constituir a nuestro estado como potencia turística . #HidalgoTieneAlgo #ExperienciasQueConectan',
        'place': 'Pachuca',
        'start': '2024-09-30',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1840847415878013018?s=46>'
    },
    {
        'id': 19,
        'title': 'Hoy recibimos a Jorge y Leo de La Gloria Tolantongo, quienes te invitan a explorar este increíble parque ecoturístico por tan solo $150. Abierto todo el año y con señalética clara para que llegues sin problemas. ¡Anímate a vivir una aventura única!',
        'place': 'Pachuca',
        'start': '2024-10-02',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1841573573556641958?s=46>'
    },
    {
        'id': 20,
        'title': '¡La transparencia no es opcional! El @itaih_hidalgo  nos capacitó a las y los servidores públicos de Turismo, en la correcta recolección, resguardo y eliminación de datos.Aprender sobre la protección de la información es clave para servir mejor a la ciudadanía.',
        'place': 'Pachuca',
        'start': '2024-10-08',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1843719693481455799?s=46>'
    },
    {
        'id': 21,
        'title': 'Gracias presidentas por aceptar esta audiencia aquí en las instalaciones de la @Feria Pachuca 2024, su talento e iniciativa fortalecerá el crecimiento de #Cardonal y #Huazalingo en materia turística. Es tiempo de mujeres',
        'place': 'Pachuca',
        'start': '2024-10-09',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1844081972701954124?s=46>'
    },
    {
        'id': 22,
        'title': '¡El corazón de Real del Monte late al ritmo de la tradición!  🥳Hoy comenzó el 16vo Festival Internacional del Paste, una celebración que une historia, sabor y cultura.  Vive la magia de este Pueblo Mágico y déjate conquistar por los sabores de Hidalgo.',
        'place': 'Real del Monte',
        'start': '2024-10-11',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1844833339640824017?s=46>'
    },
    {
        'id': 23,
        'title': '¡Ya comenzó la fiesta en Real del Monte!  Del 11 al 13 de octubre estamos celebrando el 16vo Festival Internacional del Paste y quiero que vengas a disfrutarlo conmigo. ¡Envíenme sus fotos disfrutando de los exquisitos pastes! 📸✨',
        'place': 'Real del Monte',
        'start': '2024-10-11',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1844834299821875530?s=46>'
    },
    {
        'id': 24,
        'title': 'Hoy comparezco ante la Sexagésima Sexta Legislatura del H. @CongresoHidalgo  para presentar los avances que hemos logrado en el sector turístico. 🌎 Es un honor compartir los esfuerzos que estamos realizando para fortalecer el turismo y generar más oportunidades. 🥳',
        'place': 'Pachuca',
        'start': '2024-10-14',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1845885924757868960?s=46>'
    },
    {
        'id': 25,
        'title': 'En el marco del aniversario de la Escuela Superior de Turismo IPN 🎉 se develó una placa conmemorativa a a estos 50 años de historia y de formación de muchas generaciones profesionistas👩🏻‍🦰👱🏻‍♂️ en el ámbito turístico🗺️. #PrimeroElPueblo #HidalgoTieneAlgo',
        'place': 'CDMX',
        'start': '2024-10-15',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1846274213667025312?s=46>'
    },
    {
        'id': 26,
        'title': '¡Qué gran día en el maravilloso Pueblo Mágico de Zimapán! 🌾✨ Me encuentro con el presidente municipal Hermilo Trejo Rangel y el rector de la Universidad Tecnológica Minera de Zimapán, Edgar Castillo Flores, para dar inicio a la Segunda Jornada Académica de Turismo.',
        'place': 'Zimapán',
        'start': '2024-10-16',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1846629073604194579?s=46>'
    },
    {
        'id': 27,
        'title': 'Siempre es un placer participar en el Consejo Consultivo para el Desarrollo Turístico Sustentable, porque sé del compromiso de todas a todos sus integrantes. Hoy se llevó a cabo la Segunda Sesión Extraordinaria del Estado de Hidalgo En donde le dimos la bienvenida a nuevos integrantes. Este espacio nos permite fortalecer la colaboración entre todos los actores del sector y avanzar en estrategias que promuevan un turismo responsable y sostenible.',
        'place': 'Pachuca',
        'start': '2024-10-17',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1847002356610699595?s=46>'
    },
    {
        'id': 28,
        'title': '¡Estamos en vivo con @CriterioHidalgo !',
        'place': 'Pachuca',
        'start': '2024-10-21',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1848450536523038745?s=46>'
    },
    {
        'id': 29,
        'title': '¡La adrenalina y el motocross se apoderan de Hidalgo! 📷 Este 26 y 27 de octubre, te invitamos a vivir la emoción de la próxima carrera de motocross en Mineral de la Reforma.Gracias a la Asociación Mexicana de Motociclismo (AMM) y el apoyo de Lalo Medecigo, Presidente Municipal de Mineral de la Reforma, estamos listos para recibir a los mejores pilotos en un circuito que te dejará sin aliento. Ven con tu familia y amigos, ¡y no te pierdas esta gran experiencia en carretera Pachuca-Cd. Sahagún, kilómetro 7.5, detrás del Itla!',
        'place': 'Mineral de la Reforma',
        'start': '2024-10-25',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1849916197321527347?s=46>'
    },
    {
        'id': 30,
        'title': '¡Iniciamos la semana con gira de trabajo! Nos encontramos llegando al municipio de #Zimpán, Pueblo Mágico, en donde haremos recorridos y reuniones conjuntamente con autoridades de Turismo de la región.Si ustedes son prestadores de servicios, acérquense con el municipio para poder hacer la vinculación y atenderles.',
        'place': 'Zimapán',
        'start': '2024-10-28',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1851006318988919091?s=46>'
    },
    {
        'id': 31,
        'title': 'Jacala',
        'place': 'Jacala',
        'start': '2024-10-29',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1851323879718887594?s=46>'
    },
    {
        'id': 32,
        'title': 'Quiero compartirles que me encuentro en el municipio de  #Jacala, acompañada de presidenta municipal Kendra Martínez y quiero compartirles este impresionante mural de “Los Genuinos” 💃☀️un cuarteto de huapango muy conocido en esta región.',
        'place': 'Jacala',
        'start': '2024-10-29',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1851373274024067118?s=46>'
    },
    {
        'id': 33,
        'title': '¡ #Pisaflores !',
        'place': 'Pisaflores',
        'start': '2024-10-30',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1851661033003155529?s=46>'
    },
    {
        'id': 34,
        'title': '¡¡La transformación llegó a #Pisaflores! La Sierra Gorda hidalguense sin duda tiene un potencial turístico para detonar diferentes segmentos turísticos, tales como el gastroturismo , turismo de naturaleza  y rural . Como nos lo ha encomendado nuestro Gobernador Julio Menchaca, guiar y arropar a los municipios con potencialidad turística, para así poder lograr que nuestro estado sea elegido por los turistas',
        'place': 'Pisaflores',
        'start': '2024-10-31',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1852059021160976742?s=46>'
    },
    {
        'id': 35,
        'title': '¡¡El liderazgo del gobernador @juliomenchaca_  , hace consolidar cada uno de los programas proyectados por este gobierno transformador. ✅ La unidad de este equipo multidisciplinario da resultados concretos a la gente.#PrimeroElPueblo',
        'place': 'Pachuca',
        'start': '2024-11-06',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1854267669417009555?s=46>'
    },
    {
        'id': 36,
        'title': 'Iniciamos nuestro Jueves de Audiencias recibiendo con gusto a una familia de la Huasteca, del municipio de Huejutla, para conversar sobre su experiencia en el Xantolo y compartir ideas para impulsar nuestras tradiciones. 🌺🕯️',
        'place': 'Pachuca',
        'start': '2024-11-07',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1854611526302286223?s=46>'
    },
    {
        'id': 37,
        'title': 'Hoy, tuve el gusto de recibir a María de los Ángeles Gil Soria para hablar sobre proyectos que fortalezcan el sector turístico en Hidalgo. Juntos, avanzamos hacia un #HidalgoTieneAlgo lleno de oportunidades y experiencias únicas para todos.',
        'place': 'Pachuca',
        'start': '2024-11-07',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1854613351177105672?s=46>'
    },
    {
        'id': 38,
        'title': 'Es una gran felicidad entregar estos reconocimientos que nos envía el gobernador Julio Menchaca para nuestros colaboradores, quienes han sido elementos fundamentales en la transformación de #Hidalgo. Sigamos trabajando juntos, con compromiso y dedicación, para hacer efectiva la esperanza del pueblo de Hidalgo y seguir construyendo el futuro que todos merecemos. ¡Gracias por ser parte de este cambio! #HidalgoTieneAlgo#PrimeroElPueblo',
        'place': 'Pachuca',
        'start': '2024-11-08',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1854990746291781654?s=46>'
    },
    {
        'id': 39,
        'title': '🎉 ¡Hoy en la Secretaría de Turismo de Hidalgo recibimos a Gerardo Ángeles de KingConfort! 🛏️ Si eres parte del sector turístico como prestador de servicios (hotel, cabaña o Airbnb), hay un mensaje interesante para ti. 🏨✨',
        'place': 'Pachuca',
        'start': '2024-11-08',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1855072529188004248?s=46>'
    },
    {
        'id': 40,
        'title': '😋 ¿Que tal un Ximbó este domingo? Agradezco a Pedro Santiago el hermoso detalle de traer a la Secretaría de Turismo, esta delicia de la gastronomía hidalguense: ximbó.😀🤤 Qué gusto que en el pabellón de #PueblosConSabor, en la Feria de San Francisco, hayan tenido un gran recibimiento por parte de los comensales, no por nada los Hermanos Santiago obtuvieron el primer lugar en el Concurso del Ximbó Actopan 2024.',
        'place': 'Pachuca',
        'start': '2024-11-10',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1855685096092635644?s=46>'
    },
    {
        'id': 41,
        'title': 'Hoy lunes, 11 de noviembre, tuvimos un inicio de semana increíble  ¡Con toda la energía y buenas vibras! 🎉Tuve el honor de ser entrevistada por el equipo de Telecable , para el programa “De Paseo con”:Gracias Luis Manuel González por la amena plática.📺',
        'place': 'Pachuca',
        'start': '2024-11-11',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1856078945298350144?s=46>'
    },
    {
        'id': 42,
        'title': '¡Hoy me dejaron sin palabras! 🚗Mis amigos de @Telecable, me invitaron a grabar un programa donde platicamos sobre los 84 municipios... pero lo que más me impactó fue su forma de llegar: ¡en un auto 100% libre de carbono! 🚗 ✅',
        'place': 'Pachuca',
        'start': '2024-11-11',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1856086203633676324?s=46>'
    },
    {
        'id': 43,
        'title': '🐟Ya estamos en el #Zembo, municipio de #HuascadeOcampo, en donde se llevará a cabo la rueda de prensa del “Bike Fest 2024”.Se encuentran conmigo autoridades, las y los involucrados, así como las personas de la comunidad, quienes son columna vertebral para que se lleve a cabo este evento de gran relevancia en nuestro estado.Gracias Oscar Pérez Rojas, titular del INHIDE; Luis Felipe Lugo Salinas, presidente municipal del #PuebloMágico de #HuascadeOcampo y Andrés Guajardo, director del Bike Deal, por promover y sumar esfuerzos para que este y más eventos lleguen a nuestro estado.🎊#HidalgoTieneAlgo',
        'place': 'Huasca de Ocampo',
        'start': '2024-11-12',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1856447856405516496?s=46>'
    },
    {
        'id': 44,
        'title': '😎😃 Comenzamos gira de trabajo en #TepejiDelRío, un municipio con mucho que ofrecer al turismo, por su ubicación, gastronomía e historia.#HidalgoTieneAlgo 💟',
        'place': 'Tepeji del Río',
        'start': '2024-11-13',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1856807969511674037?s=46>'
    },
    {
        'id': 45,
        'title': '👁️ De abosoluta importancia. ✍🏼 La primera actividad de la gira de trabajo en #TepejiDelRío fue la firma del Convenio de Adhesión al Código de Conducta Nacional #CNN para la Protección de Niñas, Niños y Adolescentes Mi reconocimiento a las y los integrantes de la H. Asamblea Municipal, encabezados por la alcaldesa @Tania Valdez por su voluntad para la protección de nuestras infancias. 📑#PrimeroElPueblo',
        'place': 'Tepeji del Río',
        'start': '2024-11-13',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1856808784133501072?s=46>'
    },
    {
        'id': 46,
        'title': '¡Fortaleciendo el turismo desde el corazón de nuestros Pueblos Mágicos! 🌟🤩Esta mañana, en la Tercera Sesión Extraordinaria 2024 del Consejo Consultivo para el Desarrollo Turístico Sustentable de Hidalgo, anuncié la integración de los comités de los Pueblos Mágicos. 👏🏻',
        'place': 'Pachuca',
        'start': '2024-11-14',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1857175837478355044?s=46>'
    },
    {
        'id': 47,
        'title': '¡Hoy los sabores de #Hidalgo se reunieron en Plaza Juárez! Me encuentro en compañía de diputadas, presidentas y presidentes municipales, autoridades y los protagonistas de este evento las cocinera y cocineros tradicionales de nuestro estado que con su deliciosa gastronomía nos representan dignamente como hidalguenses.#HidalgoTieneAlgo#PrimeroElPueblo',
        'place': 'Pachuca',
        'start': '2024-11-15',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1857504189934612613?s=46>'
    },
    {
        'id': 48,
        'title': '¡La tradición sabe mejor con cada bocado! 😋🍽️ Estamos en el Festival de Gastronomía Tradicional Hidalguense en Plaza Juárez y no pueden perderse el trabuco, un manjar de #SanBartoloTutotepec 😍.',
        'place': 'Pachuca',
        'start': '2024-11-15',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1857504567744749775?s=46>'
    },
    {
        'id': 49,
        'title': '¡Para mí es un honor entregar los muy bien merecidos reconocimientos a nuestras cocineras y cocineros tradicionales hidalguenses! 👩‍🍳👨‍🍳🎉 Ellos son los auténticos guardianes de nuestra gastronomía, quienes con su pasión y dedicación ponen en alto a Hidalgo en cada platillo. 🌶️🍽️',
        'place': 'Pachuca',
        'start': '2024-11-15',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1857540074315067723?s=46>'
    },
    {
        'id': 50,
        'title': '📍 Hidalgo presente en la 58° Asamblea Ordinaria de ASETUR Unimos esfuerzos con los líderes del turismo en México para seguir impulsando a nuestro estado como un destino lleno de historia, cultura y experiencias que conectan. ✅ #HidalgoTieneAlgo',
        'place': 'Jalisco',
        'start': '2024-11-19',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1858903556662681808?s=46>'
    },
    {
        'id': 51,
        'title': 'Me encuentro muy feliz, ya que 22 guías de turismo de diferentes municipios de nuestro estado, se certifican bajo la NOM 08.Estos logros, son gracias a la Dirección de Capacitación de la @SECTURHidalgo , que se encarga de profesionalizar al sector y acercarnos cada vez más a que #Hidalgo, sea potencia turística.#HidalgoTieneAlgo#PrimeroElPueblo',
        'place': 'Pachuca',
        'start': '2024-11-21',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1859630743451771279?s=46>'
    },
    {
        'id': 52,
        'title': 'Quiero compartirles que me encuentro en las instalaciones del “Hotel Gama Pachuca”🏨, en donde tuvimos la oportunidad de hablar con las gerentes, quienes además todas son mujeres 👩🏼‍🦰 y A su vez  reforzamos los lazos y las estrategias que potenciarán la derrama económica en el sector📈.#HidalgoTieneAlgo#PrimeroElPueblo',
        'place': 'Pachuca',
        'start': '2024-11-22',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1860109918633951324?s=46>'
    },
    {
        'id': 53,
        'title': '📑✔️ ¡Hoy es un gran día! Nos encontramos en el Senado de la República en la presentación de la iniciativa “Cocina y Tradición de México”. Agradezco a la asociación Tecuani Expertos en Cultura y Turismo, así como a la senadora Luisa Cortés García por esta invitación a testificar tan importante acto. 🙌',
        'place': 'CDMX',
        'start': '2024-11-26',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1861472892606681588?s=46>'
    },
    {
        'id': 54,
        'title': '🥳 ¡Hoy iniciamos una nueva etapa para Santiago de Anaya! Con el banderazo de inicio del Centro Gastronómico y Turístico, damos paso a un proyecto que impulsará el turismo, la cultura y la economía de nuestra región. ¡El futuro está comenzando ahora! ✨#HidalgoTieneAlgo',
        'place': 'Santiago de Anaya',
        'start': '2024-11-27',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1861896629525074002?s=46>'
    },
    {
        'id': 55,
        'title': 'Hoy tuvimos una excelente reunión con el Profr. Óscar Pérez Rojas, Director General del Instituto Hidalguense del Deporte. Juntos fortaleceremos el turismo deportivo en Hidalgo, un segmento clave para el desarrollo de nuestro estado.',
        'place': 'Pachuca de Soto',
        'start': '2025-01-17',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1880307010199314441?s=46>'
    },
    {
        'id': 56,
        'title': '¡Hidalgo presente en la asamblea de Madrid!Con mucho entusiasmo les comparto que fui recibida al igual que a mis homólogos de las Secretarías de Turismo de los demás estados de México con el Diputado Gustavo Eustache Con el fin de de socializar las acciones que se han realizado para potenciar la actividad turística en #Madrid. Tocando también otros temas como lo es Airbnb, eventos de impacto internacional, ordenamiento territorial y sostenibilidad social. #HidalgoTieneAlgo #PrimeroElPueblo',
        'place': 'Madrid, España',
        'start': '2025-01-20',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1881416557437600208?s=46>'
    },
    {
        'id': 57,
        'title': 'FITUR aún no comienza y ya llevamos dos días intensos de trabajo. Estamos construyendo acuerdos clave para fortalecer la política pública de turismo en Hidalgo y atraer a más visitantes españoles a nuestro hermoso estado.Hoy continuamos con este impulso en una reunión con TourEspaña y ONU Turismo, consolidando la proyección internacional de #Hidalgo.',
        'place': 'Madrid, España',
        'start': '2025-01-21',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1881738001119842474?s=46>'
    },
    {
        'id': 58,
        'title': 'Arrancamos el martes con una gran reunión en Turespaña con Miguel Sanz Castedo. Tuvimos la oportunidad de platicar sobre estrategias clave que realizamos en #Hidalgo con el liderazgo del titular del ejecutivo @juliomenchaca_',
        'place': 'Madrid, España',
        'start': '2025-01-21',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1881740359912562933?s=46>'
    },
    {
        'id': 59,
        'title': '¡México está presente en la #FITUR2025! Es un placer saludar a Enrique Galindo Ceballos, presidente de San Luis Potosí capital, y a Claudia Lorena Peralta Antiga, directora de turismo. Juntos seguimos trabajando para posicionar a nuestro país como un destino turístico increíble. ¡Vamos con todo! #HidalgoTieneAlgo FITUR',
        'place': 'Madrid, España',
        'start': '2025-01-22',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1882085818044657773?s=46>'
    },
    {
        'id': 60,
        'title': '¡Así vivimos FITUR 2025! 🌎✨ Hidalgo y México dejaron huella en uno de los escaparates turísticos más importantes del mundo. Con orgullo mostramos nuestra cultura, tradición y riqueza, demostrando que Hidalgo tiene algo único que conquistar. Este año fue solo el comienzo… en 2026 volveremos con más fuerza, porque México será el país invitado y estamos listos para brillar aún más. ¡Nos vemos en la próxima edición!',
        'place': 'Madrid, España',
        'start': '2025-01-27',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1883946527678427212?s=46>'
    },
    {
        'id': 61,
        'title': '¡De vuelta en casa, Hidalgo! 🌄✨ Tras una increíble gira en FITUR, regreso con el corazón lleno de orgullo y nuevas ideas para seguir impulsando el turismo de nuestro hermoso estado.Es un honor trabajar junto a nuestros directores en grandes proyectos que pondrán a Hidalgo en los ojos del mundo. ¡Gracias, gobernador @juliomenchaca_  , por la visión y el compromiso por que #HidalgoSeraPotencia! ',
        'place': 'Pachuca de Soto',
        'start': '2025-01-28',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1884269341144981679?s=46>'
    },
    {
        'id': 62,
        'title': 'Hoy tuve la oportunidad de conversar con los medios de comunicación sobre los logros y acuerdos obtenidos durante la @fitur_madrid En esta administración trabajamos con transparencia para mantener a la ciudadanía informada sobre acciones que benefician a nuestro estado.',
        'place': 'Pachuca de Soto',
        'start': '2025-01-28',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1884325446868951144?s=46>'
    },
    {
        'id': 63,
        'title': 'Hoy tuve la oportunidad de asistir a una reunión de trabajo con autoridades federales, estatales y municipales para generar un diálogo y coordinar acciones ante la emergencia nacional que afecta a nuestros connacionales. Las recientes medidas migratorias en Estados Unidos impactan directamente a muchos de nuestros hidalguenses que residen allá, y es fundamental unir esfuerzos para apoyarlos en este momento tan difícil. Seguimos trabajando por ellos y sus familias.#HidalgoTieneAlgo',
        'place': 'Pachuca de Soto',
        'start': '2025-01-29',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1884720342972645397?s=46>'
    },
    {
        'id': 64,
        'title': '¡Hoy fue un día de grandes avances! Tuvimos una reunión muy fructífera encabezaea por el Oficial Mayor, Edgar Orlando Ángeles Pérez, el Alcalde de Pachuca Jorge Reyes, Armando Martínez, presidente del Club Pachuca Juan Ricardo Galicia Cárdenas, director legal de FIFA México, integrantes del Club Fútbol Pachuca. Fue la primera de varias reuniones que tendremos para fortalecer el turismo deportivo en #Pachuca Que ha sido seleccionada como la primera ciudad para albergar campamentos base de futuras selecciones.',
        'place': 'Pachuca de Soto',
        'start': '2025-02-04',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1886888049222803607?s=46>'
    },
    {
        'id': 65,
        'title': 'Al apoyar a los medios locales en sus nuevos proyectos nos permite el acercamiento y difusión de la marca turística  🥳Tengo el gusto de ser la madrina del nuevo programa de Canal 10, “De Risa en Risa con Huarachín y Huarachón”.',
        'place': 'Pachuca de Soto',
        'start': '2025-02-06',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1887520411052658730?s=46>'
    },
    {
        'id': 66,
        'title': '¡En Hidalgo se respira el Carnaval! Tuvimos la oportunidad de reunirnos con diferentes dependencias estatales y municipales para poder coordinar esfuerzos y afinar detalles para este próximo viernes 21 de febrero Las calles se inunden de fiesta, 🎼 música, comparsas👺, artesanos y gastronomía Este ejercicio nos permitirá realizar un evento para que todas y todos podamos vivir nuestras tradiciones y levantar la mano ante el mundo 🌎 de que #HidalgoTieneAlgo',
        'place': 'Pachuca de Soto',
        'start': '2025-02-07',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1887893248158416925?s=46>'
    },
    {
        'id': 67,
        'title': 'En estos momentos se presenta el Informe Final de la Gestión Administrativa del Consejo Directivo de la Unión de Secretarios de Turismo de México A.C. (ASETUR 2022-2025). Un espacio clave para dar seguimiento a los logros, desafíos y avances en materia turística a nivel nacional. 🌍✨ ¡Seguimos trabajando en equipo para fortalecer el turismo en México! 🇲🇽💙 #HidalgoTieneAlgo',
        'place': 'Nayarit',
        'start': '2025-02-12',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1889723435783172265?s=46>'
    },
    {
        'id': 68,
        'title': '¡El Carnaval Hidalgo 2025 ya está aquí! Se llevó a cabo la rueda de prensa en el Recinto Ferial, donde dimos a conocer todos los detalles del esperado mega desfile. El 21 de febrero, a las 4:00 PM, el desfile saldrá del Estadio Revolución y recorrerá las calles de Pachuca con una explosión de música, danza y colores que reflejarán lo mejor de nuestras tradiciones.',
        'place': 'Pachuca de Soto',
        'start': '2025-02-14',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1890478892915335369?s=46>'
    },
    {
        'id': 69,
        'title': 'Gracias al interés y compromiso de nuestro gobernador @juliomenchaca_  por fortalecer la capacitación de prestadores de servicios y funcionarios públicos, a través de la Secretaría de Turismo, hicimos entrega de certificados. “Impartición de cursos de formación del capital humano de manera presencial grupal” EC02017.01.Este documento oficial avala a las y los capacitados como competentes para preparar y evaluar cursos de formación, impulsando así la profesionalización y calidad en el servicio.💼',
        'place': 'Pachuca de Soto',
        'start': '2025-02-17',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1891572131516883178?s=46>'
    },
    {
        'id': 70,
        'title': '¡Acompáñame a disfrutar de una experiencia única en Plaza Juárez! Ven y descubre la riqueza de nuestros sabores locales, desde platillos tradicionales hasta deliciosos postres, todo hecho con amor y dedicación',
        'place': 'Pachuca de Soto',
        'start': '2025-02-21',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1893007336081432835?s=46>'
    },
    {
        'id': 71,
        'title': 'Hoy es un día especial para honrar nuestra bandera, símbolo de identidad, historia y unidad. Acompañé al gobernador @juliomenchaca_  en la ceremonia en el Asta Bandera de Plaza Juárez, donde recordamos la grandeza de #México y el espíritu de su gente.Nuestra bandera, reconocida como la más hermosa del mundo, nos inspira a seguir construyendo un #Hidalgo fuerte y lleno de oportunidades. ❤️🤍💚',
        'place': 'Pachuca de Soto',
        'start': '2025-02-24',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1894118769129128236?s=46>'
    },
    {
        'id': 72,
        'title': '¡Iniciamos este martes con una gran noticia! ✨ Hoy asistí a la presentación de una iniciativa histórica que declara a nuestro estado de #Hidalgo como la cuna defensora de los derechos humanos de las cocineras y cocineros tradicionales. Este reconocimiento busca proteger y visibilizar a quienes han dedicado su vida a preservar nuestras raíces culinarias. Me llena de orgullo acompañar este esfuerzo impulsado por la Fundación Universal Tercer Milenio A.C., con el apoyo de Rafael García Vela y Lucero Wella.🌶',
        'place': 'Singuilucan',
        'start': '2025-02-25',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1894481237571465557?s=46>'
    },
    {
        'id': 73,
        'title': 'Arrancamos un día más de trabajo, esta vez en #Tecozautla . Quiero compartirles esta postal de un producto turístico imperdible de la región, el viñedo “Tierra y almas”🍷🍇, es un imperdible de Tecozautla, además de su oferta en balnearios 🌊y hoteles 🏨.#HidalgoTieneAlgo',
        'place': 'Tecozautla',
        'start': '2025-02-26',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1894811461978870034?s=46>'
    },
    {
        'id': 74,
        'title': '¡Este 22 de marzo “Tierra y almas” tiene un plan perfecto para ti! 🍇🍷 Disfruta de un maridaje a cargo de Hñähñú Cocina Otomí de Raíz , que deleitará a cada uno de tus sentidos. El enoturismo en su máximo esplendor en #Tecozaulta, no se pierdan la oportunidad de disfrutar de una experiencia gastronómica inigualable. Para más información ingresen a las rede de Tierra y Almas 📲',
        'place': 'Tecozautla',
        'start': '2025-02-27',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1895147697079812405?s=46>'
    },
    {
        'id': 75,
        'title': '¡Hoy es un día histórico para el turismo en Hidalgo! Desde el @CongresoHidalgo , celebramos la presentación de dos iniciativas clave para fortalecer el sector: Turismo en ejidos: Reforma para impulsar proyectos turísticos en comunidades rurales.',
        'place': 'Pachuca de Soto',
        'start': '2025-03-04',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1897042459127144770?s=46>'
    },
    {
        'id': 76,
        'title': '<https://x.com/lizquintanarg/status/1897042459127144770?s=46><https://x.com/lizquintanarg/status/1897042459127144770?s=46><https://x.com/lizquintanarg/status/1897042459127144770?s=46>',
        'place': 'Omitlán',
        'start': '2025-03-06',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1897770382108553231?s=46>'
    },
    {
        'id': 77,
        'title': 'Hoy tuve el honor de reunirme con Ramiro Bautista Rosales el presidente de la organización Hidalguenses Sur de California 🇲🇽🌎con quien platicamos sobre próximos eventos que fortalecerán los lazos entre nuestros paisanos y nuestro estado de Hidalgo.',
        'place': 'Pachuca de Soto',
        'start': '2025-03-07',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1898128468929343780?s=46>'
    },
    {
        'id': 78,
        'title': 'En la Secretaría de Turismo del Estado de Hidalgo reconocemos y agradecemos a las mujeres hidalguenses trabajadoras que, con su esfuerzo y dedicación, colocan a nuestro estado en el mapa turístico. A las hoteleras, restauranteras, agencias de viajes, socorristas, guías, servidoras públicas y a todas aquellas que, con su pasión, logran hacer brillar a Hidalgo. Hoy, rendimos homenaje a su incansable labor. ¡Gracias por poner en alto a nuestro estado!',
        'place': 'Pachuca de Soto',
        'start': '2025-03-10',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1899163283740852466?s=46>'
    },
    {
        'id': 79,
        'title': 'Con gran satisfacción y compromiso, concluimos nuestra participación en la 60ª Asamblea Ordinaria de la Unión de Secretarios de Turismo A.C. Este evento nos dejó valiosas alianzas y acuerdos que fortalecerán el turismo. Seguiremos trabajando con pasión y dedicación bajo los principios del Gobernador Julio Menchaca, para hacer de nuestro país un destino turístico de clase mundial🌍✨',
        'place': 'Quintana Roo',
        'start': '2025-03-11',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1899582953287520375?s=46>'
    },
    {
        'id': 80,
        'title': '',
        'place': 'Pachuca de Soto',
        'start': '2025-03-',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1895147697079812405?s=46>'
    },
    {
        'id': 81,
        'title': '¡Hoy es un gran día para el turismo! En el Zócalo de la Ciudad de México se llevará a cabo el banderazo del programa "Colibrí Viajero 2025". Este emocionante proyecto busca promover el turismo en grupos donde le es difícil tener acceso a niños y adultos mayores en situación vulnerable a conocer destinos turísticos que brinden bienestar.',
        'place': 'Pachuca de Soto',
        'start': '2025-03-12',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1899881666413289520?s=46>'
    },
    {
        'id': 82,
        'title': '¡El AIFA vuela alto con el Prix Versailles! El gobernador @juliomenchaca_  estuvo presente en la develación de la placa que reconoce al Aeropuerto Internacional Felipe Ángeles (AIFA) como uno de los aeropuertos más bellos del mundo 2024, otorgado por el Prix Versailles.Este prestigioso galardón de la UNESCO destaca su diseño innovador, impacto cultural y armonía arquitectónica. Un orgullo que eleva a México en la escena internacional. ¡Seguimos despegando hacia el futuro!',
        'place': 'Pachuca de Soto',
        'start': '2025-03-14',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1900649842231169512?s=46>'
    },
    {
        'id': 83,
        'title': 'Nos encontramos en el Colegio de Ingenieros Civiles del Estado de Hidalgo 🏛️, es para mi un placer acompañar a la presidenta Iliana López Mariano  🤝 y compartir los emocionantes planes que tenemos en conjunto 🌟 ',
        'place': 'Pachuca de Soto',
        'start': '2025-03-21',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1903204099195121823?s=46>'
    },
    {
        'id': 84,
        'title': '¡Iniciamos la semana trabajando por el turismo de Hidalgo! Como cada lunes, nos reunimos con los Directores de cada área de la Secretaría de Turismo para seguir fortaleciendo nuestro estado como un destino imperdible.Siguiendo la visión del gobernador @juliomenchaca_   trabajamos con compromiso y estrategia porque #HidalgoSeráPotencia.¡Seguimos impulsando el turismo y llevando a Hidalgo al siguiente nivel! 💚🏔️ #HidalgoTieneAlgo ',
        'place': 'Pachuca de Soto',
        'start': '2025-03-24',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1904238878938280258?s=46>'
    },
    {
        'id': 85,
        'title': '¡Hidalgo está listo para brillar en la gran pantalla! La Secretaría de Turismo de Hidalgo visita Televisa para hablar sobre una nueva producción en nuestro estado. Con paisajes únicos y escenarios que cuentan historias.facebook.com/share/v/1HaNUc…#HidalgoTieneAlgo',
        'place': 'CDMX',
        'start': '2025-03-25',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1904640837713035544?s=46>'
    },
    {
        'id': 86,
        'title': 'Agencias y tour operadoras de Hidalgo se dieron cita del día de hoy en la sala 4D del Museo Paleontológico Quinametzin 🦣para poder informarse acerca de las herramientas que ofrece el Grupo Aeroportuario, Ferroviario, de Servicios Auxiliares y Conexos, Olmeca-Maya-Mexica Hacer de #Hidalgo potencia turística es una prioridad en el gobierno de @juliomenchaca_   continuamos creando las condiciones para que el turismo de nuestro estado se vea impulsado, con el apalancamiento de instituciones que sumen a nuestro objetivo ',
        'place': 'Pachuca de Soto',
        'start': '2025-03-26',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1904993125644271835?s=46>'
    },
    {
        'id': 87,
        'title': 'Iniciamos la semana con una mesa de trabajo clave junto al Director de Gestión de Destino de la Secretaría de Turismo Federal. Unidos, seguimos impulsando estrategias para consolidar a Hidalgo como un referente turístico en México.',
        'place': 'Pachuca de Soto',
        'start': '2025-03-31',
        'color': 'var(--wine)',
        'description': '<https://x.com/lizquintanarg/status/1906777554234556926?s=46>'
    },
    {
        'id': 88,
        'title': 'Hoy firmamos la carta de intención para la Alianza Metropolitana de Turismo Social, en el marco del inicio del #TianguisTurístico2025. 🤝🏼 Unimos esfuerzos, sueños y destinos para acercar el turismo a más personas. ¡Lo mejor está por venir! 🌎❤️ #HidalgoTieneAlgo',
        'place': 'Baja California',
        'start': '2025-04-28',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1916956302581858379>'
    },
    {
        'id': 89,
        'title': 'En el #TianguisTurístico2025 en #BajaCalifornia, firmamos el convenio “Coordinación para el Fortalecimiento del Turismo Comunitario” con #UNESCO y ocho estados, incluido #Hidalgo. Impulsamos el turismo comunitario como motor de desarrollo, identidad y bienestar social.',
        'place': 'Baja California',
        'start': '2025-04-29',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1917310522707374539>'
    },
    {
        'id': 90,
        'title': '¡#Huasca brilla en el #TianguisTurístico2025! Ganador en la categoría de Bienestar en los Premios Mágicos México Excelencias.Orgullo de Hidalgo y ejemplo para el mundo. ¡Felicidades a nuestro primer #PuebloMágico! 🏅🌿✨#HidalgoTieneAlgo #PrimeroElPueblo',
        'place': 'Baja California',
        'start': '2025-05-01',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1918170762940432748>'
    },
    {
        'id': 91,
        'title': 'Esta mañana acompañé al gobernador @juliomenchaca_ en la reunión mensual de gabinete, reafirmando que el turismo es motor de desarrollo en #Hidalgo. 🤝🏼 Escuchar al pueblo nos permite avanzar con claridad y sentido social. #PrimeroElPueblo',
        'place': 'Pachuca de Soto',
        'start': '2025-05-05',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1919504895931002934>'
    },
    {
        'id': 92,
        'title': 'Esta mañana, tuve el placer de realizar un recorrido con nuestra secretaria federal,  @josefinarodzam, por el Centro Interactivo "Mundo Fútbol" y el "Salón de la Fama" de nuestra ciudad de #Pachuca. Allí, pudimos mostrarle nuestro legado en el fútbol. 🥅⚽️ #HidalgoTieneAlgo',
        'place': 'Pachuca de Soto',
        'start': '2025-05-08',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1920593104480186672>'
    },
    {
        'id': 93,
        'title': 'Acompañé a la secretaria de Turismo federal, @josefinarodzam, en su visita a las Grutas de Xoxafi en #SantiagoDeAnaya 🌄✨ Un gran ejemplo de turismo comunitario: desarrollo local, respeto por la naturaleza y orgullo por nuestras raíces 🤝🏼🌱#HidalgoTieneAlgo  #PrimeroElPueblo',
        'place': 'Pachuca de Soto',
        'start': '2025-05-08',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1920698650440642983>'
    },
    {
        'id': 94,
        'title': '¡#Tolcayuca se llena de color! 🎨 Con #RutasMágicasDeColor 2025 impulsamos el turismo, fortalecemos la economía local y celebramos lo que nos hace únicos. 💪🏻✨ #HidagoTieneAlgo #PrimeroElPueblo @juliomenchaca_| @gobiernohidalgo',
        'place': 'Tolcayuca',
        'start': '2025-05-19',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1924556271249653854>'
    },
    {
        'id': 95,
        'title': 'Seguimos en las Jornadas Técnicas de Turismo Inteligente España–México 🇪🇸🇲🇽 Tuve la oportunidad de charlar con Nayeli Zúñiga y Omar Gutiérrez sobre innovación, digitalización y el futuro del turismo en #México e #Hidalgo.  ¡Un diálogo que suma y nos impulsa! 🌐✈️',
        'place': 'CDMX',
        'start': '2025-05-20',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1924915268091859013>'
    },
    {
        'id': 96,
        'title': '¡Qué gusto coincidir con el subsecretario Sebastián Ramírez en las Jornadas de Turismo Inteligente España🇪🇸–México🇲🇽! Intercambiar ideas sobre el futuro del turismo siempre inspira. ¡Sigamos construyendo puentes para que el mundo sepa que #HidalgoTieneAlgo! 🌍🛬',
        'place': 'Omitlán',
        'start': '2025-05-20',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1924874967906152563>'
    },
    {
        'id': 97,
        'title': '¡La emoción del Mundial de Clubes llega a #Hidalgo! Prepárate para vivir el Trophy Tour y tomarte la foto con la copa que levanta al mejor equipo del mundo 🏆⚽ ¡La experiencia es totalmente gratis!No te pierdas esta fiesta del fútbol que une al mundo entero. #HidalgoTieneAlgo',
        'place': 'Pachuca de Soto',
        'start': '2025-05-22',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1925675161774145884>'
    },
    {
        'id': 98,
        'title': 'Día de gira y también de audiencias 👩‍💼🌱 Hoy recibí a Eduardo y Christian de Bioproducts, una empresa que trabaja desde uno de nuestros #PueblosMágicos en un modelo cero plásticos. Refrendamos el compromiso con la Ley de Turismo Sustentable: si es compostable, ¡es mejor! ♻️💚',
        'place': 'Pachuca de Soto',
        'start': '2025-05-22',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1925683560410685817>'
    },
    {
        'id': 99,
        'title': 'Esta mañana disfrutamos una jornada de convivencia en el Parque Cultural Hidalguense. En el marco del 🧡 #DíaNaranja, organizamos un cuadrangular de futbol ⚽ entre compañeras y compañeros de la Secretaría. ¡Así se vive el espíritu de #HidalgoTieneAlgo!',
        'place': 'Pachuca de Soto',
        'start': '2025-05-23',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1926002352995131725>'
    },
    {
        'id': 100,
        'title': 'Hidalgo se une con orgullo a Tecuani: Cocina y Tradición de México 🌽🌶️. Desde el Congreso del Estado, celebramos nuestras raíces y fortalecemos el turismo comunitario junto a grandes aliados. 🫱🏻‍🫲🏽',
        'place': 'Pachuca de Soto',
        'start': '2025-05-26',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1927098718777483428>'
    },
    {
        'id': 101,
        'title': '#Hidalgo presente en #ARLAG 2025 ✈️ mostrando al mundo la belleza y diversidad de nuestro estado. Conectamos con actores clave del turismo nacional e internacional para atraer más turismo, más inversión y más bienestar para todas y todos los #hidalguenses. #HidalgoTieneAlgo',
        'place': 'Guadalajara',
        'start': '2025-05-29',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1930028837577855335>'
    },
    {
        'id': 103,
        'title': '¡#Hidalgo llegó a #QuintanaRoo! ☀️🌊 Tuve el gusto de reunirme con agencias de viaje para compartir todo lo que nuestro estado tiene para ofrecer: cultura, naturaleza, gastronomía y experiencias que se quedan en el corazón. 🌄🫶 #HidalgoTieneAlgo #PrimeroElPueblo',
        'place': 'Quintana Roo',
        'start': '2025-06-03',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1928189461164155185>'
    },
    {
        'id': 104,
        'title': 'Participamos en un importante encuentro turístico gracias a la invitación de Alberto Albarrán, director de la Asociación de Hoteles CDMX, y Roxana Vargas, presidenta de la Asociación de Hoteles y Moteles de Hidalgo.',
        'place': 'Pachuca',
        'start': '2025-06-17',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1935058718095212666>'
    },
    {
        'id': 105,
        'title': 'Hidalgo celebrará el Primer Festival de la Barbacoa del #ValleDelMezquital este 29 de junio en #Ixmiquilpan 🐑🔥 Una fiesta cultural y gastronómica que reconoce a quienes preservan esta tradición. #HidalgoTieneAlgo #PrimeroElPueblo',
        'place': 'Pachuca',
        'start': '2025-06-17',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1935106607244873848>'
    },
    {
        'id': 106,
        'title': 'Con gran entusiasmo, #Hidalgo participó en un encuentro de intercambio turístico, cultural y económico con #NuevoLeón. Agradecemos profundamente la recepción y disposición para construir un turismo más fuerte y colaborativo. #HidalgoTieneAlgo #PrimeroElPueblo',
        'place': 'Nuevo León',
        'start': '2025-06-18',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1935422919267729566>'
    },
    {
        'id': 107,
        'title': 'Acompañamos con gusto el nombramiento de Elena Carballal Orgado como presidenta de @CaniracHgo🍽️✨ Reconocemos el papel clave de la industria restaurantera en el desarrollo económico y turístico del estado. Confiamos en que esta nueva etapa traerá grandes logros. ¡Éxito!',
        'place': 'Pachuca',
        'start': '2025-06-20',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1936295378107646306>'
    },
    {
        'id': 108,
        'title': 'Se presentó una nueva selección de vinos internacionales en #Huichapan, convirtiéndolo en punto de encuentro para el enoturismo y la gastronomía. Con etiquetas de #México, #Hidalgo y otros rincones del mundo. #HidalgoTieneAlgo #PrimeroElPueblo',
        'place': 'Huichapan',
        'start': '2025-06-21',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1936631694477386234>'
    },
    {
        'id': 109,
        'title': 'Hoy desde el Senado, #Hidalgo se suma al programa federal “Cocina y Tradición de México” con #HidalgoSabe, una apuesta por nuestras raíces, sabores y saberes que fortalecen el turismo y la economía local. 🌽🔥 ¡Nuestra cocina, orgullo nacional! #HidalgoTieneAlgo',
        'place': 'CDMX',
        'start': '2025-06-24',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1937648973486928022>'
    },
    {
        'id': 110,
        'title': 'Hoy visité el #PuebloMágico de #Huichapan y recorrí el centro ecoturístico #Dandhó, un espacio de gran riqueza natural y cultural que impulsamos para fortalecer el turismo de naturaleza en la región. 🌿✨ #HidalgoTieneAlgo #PrimeroElPueblo',
        'place': 'Huichapan',
        'start': '2025-06-27',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1938829013688172666>'
    },
    {
        'id': 111,
        'title': 'En nuestra visita a #Huichapan conocimos el taller de Don Rubén Hernández, artesano de cantera. ¡Sus piezas, llenas de color y detalle, reflejan el talento de la región!  📲 Cotizaciones: 761 7822 094 📩 moldurasydecoraciones@hotmail.com #HidalgoTieneAlgo #PrimeroElPueblo',
        'place': 'Huichapan',
        'start': '2025-06-27',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1938829561963188699>'
    },
    {
        'id': 112,
        'title': 'Hoy se inauguró el 1er Festival de la Barbacoa del #ValleDelMezquital en el Parque Acuático Dios Padre. La barbacoa es tradición viva, orgullo y sabor que nos une. 🐑✨ #HidalgoTieneAlgo #PrimeroElPueblo',
        'place': 'Ixmiquilpan',
        'start': '2025-06-29',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1939536972759892067>'
    },
    {
        'id': 113,
        'title': 'Gran momento en el 1er Festival de la Barbacoa del Valle del Mezquital. Se realizó el pase de estafeta hacia #SantiagoDeAnaya, reafirmando el compromiso de preservar esta gastronomía ancestral. ¡Viva la barbacoa y viva el Valle del Mezquital! 🐑✨',
        'place': 'Ixmiquilpan',
        'start': '2025-06-29',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1939537488659542354>'
    },
    {
        'id': 114,
        'title': '¡Histórica y bella #Huichapan, ganadora de la mejor salsa en el 1er Festival de la Barbacoa del Valle del Mezquital! Su sabor y tradición conquistaron paladares, demostrando que la pasión por nuestra gastronomía sigue viva.🍅✨ #HidalgoTieneAlgo #PrimeroElPueblo',
        'place': 'Ixmiquilpan',
        'start': '2025-06-29',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1939537865874043039>'
    },
    {
        'id': 115,
        'title': 'Esto fue parte del 2° Foro Gastronómico Internacional de la Universidad de Tollancingo. Cocineras tradicionales brillaron con saberes y sabores, demostrando que la tradición es base de la innovación. Sigamos construyendo espacios que reconozcan su conocimiento.',
        'place': 'Tulancingo',
        'start': '2025-07-04',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1941246501256298820>'
    },
    {
        'id': 116,
        'title': '✨ Conmemoramos 10 años del Acueducto del Padre Tembleque como Patrimonio Mundial. 🌍 En #Zempoala se realizó una jornada cultural para honrar este legado reconocido por la #UNESCO. Agradecemos a quienes se sumaron a este importante festejo.',
        'place': 'Zempoala',
        'start': '2025-07-08',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1942818912485400777>'
    },
    {
        'id': 117,
        'title': 'Tuve el honor de participar en la Estrategia Nacional Avanzamos por México, junto al presidente municipal de Mineral del Monte, Edmundo Méndez Tejeda. 🫱🏼‍🫲🏽✨ Este convenio entre BBVA y la Secretaría de Turismo impulsa la digitalización de los #PueblosMágicos. #HidalgoTieneAlgo',
        'place': 'Mineral del Monte',
        'start': '2025-07-08',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1939537865874043039>'
    },
    {
        'id': 118,
        'title': '🎉 ¡Regresa Colorín Fest a Plaza Explanada Pachuca! 📅 26 y 27 de julio | 2 a 7 PM Te esperan talleres, teatro, inflables, carrera de botargas 🐾 y jornada de adopción 🐶. Además, un pabellón turístico con sabor a #PueblosMágicos y tradición. #HidalgoTieneAlgo #PrimeroElPueblo',
        'place': 'Pachuca',
        'start': '2025-07-22',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1942819481539207333>'
    },
    {
        'id': 119,
        'title': 'Hace unos días tuve la oportunidad de visitar el Hotel Campestre El Mirador, un nuevo espacio para disfrutar la naturaleza con una vista inigualable. Fuimos parte del corte de listón inaugural y recorrimos sus increíbles rutas en RZR y cuatrimoto.',
        'place': 'Santiago Tulantepec',
        'start': '2025-07-22',
        'color': 'var(--wine)',
        'description': '<https://x.com/LizQuintanarG/status/1947778137418605043>'
    }
];
